import { RootState } from "core-integration/src/store";
import { getEntry } from "core-integration/src/store/entries/reducers";
import { getCurrentEvent } from "core-integration/src/store/events/reducers";
import { getPlayerData } from "core-integration/src/store/player/reducers";
import { ILoggedInPlayer } from "core-integration/src/store/player/types";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link } from "react-router";
import Button from "../../Button";
import { ControlArrowRight } from "../../icons/Arrows";
import {
  ArrowLink,
  EventStatus,
  ScoreboardBody,
  ScoreboardFooter,
  ScoreboardHeader,
  ScoreboardHeading,
  ScoreboardInner,
  ScoreboardMain,
  ScoreboardUnit,
  ScoreboardUnitHeading,
  ScoreboardUnitValue,
  StyledPointsScoreboard,
} from "./styles";

const PointsScoreboard = () => {
  const { t } = useTranslation();

  const player = useSelector(getPlayerData) as ILoggedInPlayer;
  const entry = useSelector((state: RootState) =>
    getEntry(state, player.entry),
  );
  const now = useSelector(getCurrentEvent);

  if (!now || !entry) {
    return null;
  }

  const buttons = now.finished
    ? [
        { to: "/my-team", text: t("navigation.myTeam", "My Team") },
        {
          to: "/transfers",
          text: t("createSquad.makeTransfers", "Make Transfers"),
        },
      ]
    : [
        {
          to: `/entry/${player.entry}/event/${now.id}`,
          text: t("status.points", "Points"),
        },
        { to: "/leagues", text: t("status.checkLeagues", "Check Leagues") },
      ];

  const eventStatus = now.finished
    ? t("statusBar.complete", "Final")
    : t("statusBar.live", "live");

  return (
    <StyledPointsScoreboard>
      <ScoreboardInner>
        <ScoreboardBody>
          <ScoreboardHeader>
            <ScoreboardHeading>{now.name}</ScoreboardHeading>
            <EventStatus $isLive={!now.finished}>{eventStatus}</EventStatus>
          </ScoreboardHeader>
          <ScoreboardMain>
            <ScoreboardUnit>
              <ScoreboardUnitHeading>
                {t("eventInfo.averageScore", "Average")}
              </ScoreboardUnitHeading>
              <ScoreboardUnitValue>
                {now.average_entry_score || "-"}
              </ScoreboardUnitValue>
            </ScoreboardUnit>
            <ScoreboardUnit>
              <ScoreboardUnitHeading>
                {now.highest_scoring_entry ? (
                  <ArrowLink
                    to={`/entry/${now.highest_scoring_entry}/event/${now.id}`}
                  >
                    {t("eventInfo.highestScore", "Highest")}
                    <ControlArrowRight color="white" />
                  </ArrowLink>
                ) : (
                  t("eventInfo.highestScore", "Highest")
                )}
              </ScoreboardUnitHeading>
              <ScoreboardUnitValue>
                {now.highest_scoring_entry ? (
                  <span>{now.highest_score}</span>
                ) : (
                  "-"
                )}
              </ScoreboardUnitValue>
            </ScoreboardUnit>
            {entry.started_event <= now.id && (
              <ScoreboardUnit>
                <ScoreboardUnitHeading>
                  <ArrowLink to={`/entry/${player.entry}/event/${now.id}`}>
                    {t("eventInfo.yourScore", "Points")}
                    <ControlArrowRight color="white" />
                  </ArrowLink>
                </ScoreboardUnitHeading>
                <ScoreboardUnitValue>
                  {entry.summary_event_points}
                </ScoreboardUnitValue>
              </ScoreboardUnit>
            )}
          </ScoreboardMain>
        </ScoreboardBody>
        <ScoreboardFooter>
          {buttons.map(({ to, text }) => (
            <Button key={to} to={to} variant="primary" as={Link} width={1}>
              {text}
            </Button>
          ))}
        </ScoreboardFooter>
      </ScoreboardInner>
    </StyledPointsScoreboard>
  );
};

export default PointsScoreboard;
